export const tituloPrincipal = "📢 Comandos do Chat";

export const subTitulo = '  Para fazer a conexão dos equipamentos via chat, utilize os seguintes comandos:'

export const exemploMensagemChat = '  ➤ O ícone será exibido com o nome escolhido.'

export const comandoAnlisarGrafico = ' Análise de Gráfico: Comandos '